/* LUMUNO "Buy 2, save 15%": one-tap add buttons (PDP + cart drawer) and quantity label. */
(function () {
  'use strict';

  function gid(id) { return 'gid://shopify/ProductVariant/' + id; }

  // Shopify.actions.updateCart adds the given quantity to the cart (tested: it is additive), then refreshes the drawer.
  function addVariants(ids) {
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      var lines = ids.map(function (id) { return { merchandiseId: gid(id), quantity: 1 }; });
      return actions.updateCart({ lines: lines }, { event: { context: 'product' } }).then(function () {
        if (actions.openCart) actions.openCart();
      });
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    }).then(function () { window.location.href = '/cart'; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lum-add]');
    if (!btn) return;
    e.preventDefault();
    var ids = String(btn.getAttribute('data-lum-add')).split(',').filter(Boolean);
    if (!ids.length) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    addVariants(ids)
      .catch(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
        }).then(function () { window.location.href = '/cart'; });
      })
      .finally(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  });

  // Visible "Quantity" label above the product-page quantity selector.
  function labelQty() {
    document.querySelectorAll('.product-details quantity-selector-component, .product-details .quantity-selector').forEach(function (q) {
      var wrap = q.parentElement;
      if (!wrap || wrap.querySelector('.lum-qty-label')) return;
      var input = q.querySelector('input');
      var lab = document.createElement(input && input.id ? 'label' : 'span');
      lab.className = 'lum-qty-label';
      lab.textContent = 'Quantity';
      if (input && input.id) lab.setAttribute('for', input.id);
      wrap.insertBefore(lab, q);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', labelQty); else labelQty();
})();
